import { render, staticRenderFns } from "./WechatEditName.vue?vue&type=template&id=f5be7bac&scoped=true&"
import script from "./WechatEditName.vue?vue&type=script&lang=js&"
export * from "./WechatEditName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5be7bac",
  null
  
)

export default component.exports